import React from 'react';

// hooks
import { useFetchWorkspaces } from 'Shared/utils/hooks';

// components
import Spinner from 'Shared/components/Spinner';
import TeamGroupSection from 'Shared/components/navigation/TeamGroupSection/TeamGroupSection';
import CreateWorkspaceButton from 'Shared/components/CreateWorkspaceButton/CreateWorkspaceButton';
import { useTranslation } from 'Shared/utils/hooks/use-translation';

// styles
import './ZoomLandingPage.scss';

const ZoomLandingPage = () => {
  const [isWorkspaceFetching] = useFetchWorkspaces();
  const { tr } = useTranslation();

  return (
    <div className="ZoomLandingPage">
      {isWorkspaceFetching ? (
        <Spinner activeIf />
      ) : (
        <div className="ZoomLandingPage__content">
          <h5 className="ZoomLandingPage__header">{tr('perform.zoom.landing_page.header')}</h5>
          <div className="ZoomLandingPage__action">
            <CreateWorkspaceButton />
          </div>
          <TeamGroupSection />
        </div>
      )}
    </div>
  );
};

export default ZoomLandingPage;
